export default {
  provide() {
    return {
      'treeNodeParent': this,
      'deep': this.deep + 1
    };
  },
  inject: ['tree', 'treeNodeParent', 'deep'],
  data() {
    return {
      treeNodeChildren: [],
      selected: false
    };
  },
  computed: {
    _isSelected() {
      return this.treeNodeChildren.every(child => {
        return child._isSelected;
      });
    },
    _isHalfSelected() {
      if (this._isSelected) {
        return false;
      }
      return this.treeNodeChildren.some(child => {
        return child._isHalfSelected || child._isSelected;
      });
    },
    _isExpanded() {
      return this.tree.isExpanded(this);
    }
  },
  mounted() {
    this.tree.addNode(this);
    this.treeNodeParent && this.treeNodeParent.addChild && this.treeNodeParent.addChild(this);
  },
  beforeDestroy() {
    this.tree.removeNode(this);
    this.treeNodeParent && this.treeNodeParent.removeChild && this.treeNodeParent.removeChild(this);
  },
  methods: {
    addChild(child) {
      this.treeNodeChildren.push(child);
    },
    removeChild(child) {
      const idx = this.treeNodeChildren.indexOf(child);
      if (idx > -1) {
        this.treeNodeChildren.splice(idx, 1);
      }
    },
    getIndex() {
      return this.index;
    },
    toggleExpand() {
      this.tree.toggleExpand(this);
    },
    setExpand(expanded) {
      this.tree.setExpand(this, expanded);
    }
  }
};
